<app-view-title [showHeader]="false" [isPrimaryColor]="true"></app-view-title>
<view-content [centered]="true" [fullscreen]="true">
  @if(loading) {
  <app-loading-screen [centered]="true" [invertedColor]="true" title="{{ 'Intellitrailer.Rental.Stop.EndingRental' | translate : 'Ending rental' }}" description="{{ 'Intellitrailer.Rental.Start.EndingRental2' | translate : 'This will just take a moment' }}"></app-loading-screen>
  }
  @else {
    <h2>{{ 'Intellitrailer.Rental.Stop.Failed' | translate : 'Could not return trailer' }}</h2>
    <app-card>
      <p>{{ 'Intellitrailer.Rental.Stop.msgErrorCode' | translate : 'ErrorCode' }}:  <b>{{ errorCode }}</b></p>
      <img src="/Images/ErrorImg.png" />

      <!-- Wrong Status -->
      @if(errorCode == '10' || errorCode == '1') {
      <p>{{ 'Intellitrailer.Rental.Stop.Error10Message1' | translate : 'The return cannot be completed. The booking may already be returned, or there might be an issue with the booking details.' }}</p>
      <br />
      <p>{{ 'Intellitrailer.Rental.Stop.Error10Message2' | translate : 'Please check and try again.' }}</p>
      <button mat-raised-button (click)="goTo('MyBookings')">
        {{ 'Intellitrailer.Rental.Stop.btnActionError10' | translate : 'Go back' }}
        <mat-icon>undo</mat-icon>
      </button>
      }

      <!-- No Rental Found -->
      @if(errorCode == '8') {
        <p>{{ 'Intellitrailer.Rental.Stop.Error8Message1' | translate : 'The return cannot be completed. We couldn’t find the booking, or there might be an issue with the booking details.' }}</p>
        <br />
        <p>{{ 'Intellitrailer.Rental.Stop.Error8Message2' | translate : 'Please check and try again.' }}</p>
        <button mat-raised-button (click)="goTo('MyBookings')">
          {{ 'Intellitrailer.Rental.Stop.btnActionError8' | translate : 'Go back' }}
          <mat-icon>undo</mat-icon>
        </button>
      }

    </app-card>
  }
</view-content>
